<!-- components/BaseInputWithContextMenu.vue -->
<template>
  <div :id="containerId" oncontextmenu="return false;">
    <div v-if="contextMenuInitialized && !isReadOnlyState && contextMenuItems.length > 0">
      <ejs-contextmenu
        ref="contextmenu" 
        :id="'contextmenu-' + targetId" 
        :target="'#' + containerId"
        :items="contextMenuItems" 
        :select="onContextMenuSelect"
        :beforeOpen="onBeforeContextMenuOpen"
        :enable="contextMenuItems.length > 0"
        :beforeItemRender='onItemRender'
      ></ejs-contextmenu>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { contextMenuMixin } from '@/common/contextMenuMixin'

export default {
  name: 'BaseInputWithContextMenu',
  mixins: [contextMenuMixin],
  
  props: {
    isReadOnly: Boolean,
    value: [String, Number],
    control: Object,
    additionalMenuItems: {
      type: Array,
      default: () => []
    },
    enableSpeechFeatures: {
        type: Boolean,
        default: true
    },
    targetId: {
      type: String,
      required: true
    },
    enableSystemOptions: {
      type: Boolean,
      default: true
    },
    isCkeditor: {
      type: Boolean,
      default: false
    },
     controlId: { 
      type: String,
      default: ''
    },
  },
  watch: {
    additionalMenuItems: {
      immediate: true,
      deep: true,
      handler() {
        this.loadMenuItems();
      }
    }
  },
  computed: {
    isReadOnlyState() {
      return this.isReadOnly;
    },
    
    inputValue() {
      return this.value;
    },
    
    inputElementId() {
      return this.targetId;
    }
  },
  data() {
    return {
      containerId: '',
      contextMenuInitialized: false,
      isCKEditor: false,
      ckeditorInstanceRef: null,
      childComponent: null
    }
  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', newValue);
    },

    setChangedStatus() {
      if (this.control) {
        const changed = {
          "ControlId": this.control.controlID,
          "Changed": true,
          "NoteId": this.NoteId
        };
        this.$emit('control-changed', changed);
      }
    },

    getControlId() {
        // 1) If the parent  explicitly passed a controlId, use it
      if (this.controlId && this.controlId.length > 0) {
        return this.controlId;
      }

      // 2) If this.control object exists, use its controlID
      if (this.control && this.control.controlID) {
        return this.control.controlID;
      }

      // 3) fallback: targetId (html id type 'target-...')
      return this.targetId || '';
    },
    // Load menu items
    loadMenuItems() {
      this.contextMenuItems = this.loadContextMenuItems(this.additionalMenuItems, this.enableSystemOptions);
      return true;
    },
    // Overwrite to control speech features
    isSpeechEnabled() {
      return this.enableSpeechFeatures;
    },

    async onBeforeContextMenuOpen() {
      this.loadMenuItems();
    },

    initializeContainer() {
      if (!this.targetId) {
        return null;
      }
      // Create unique ID for the container
      const containerId = `ctx-container-${this.targetId}`;
      return containerId;
    },

    setCKEditorRef(ref) {
      this.ckeditorInstanceRef = ref;
      this.isCKEditor = this.isCkeditor || !!ref;
    },

    getCKEditorRef() {
      return this.ckeditorInstanceRef;
    },
  },

  mounted() {
    if (!this.targetId ) {
      console.warn('[BaseInputWithContextMenu] No targetId proporcionado');
      return;
    }

    this.containerId = this.initializeContainer();

    this.$nextTick(() => {
      if (this.$el && this.containerId) {
        this.$el.id = this.containerId;
      }

      // Try to obtain the item safely
      let el = null;

      //If targetId comes with '#' we clean it
      const cleanId = this.targetId.startsWith('#')
        ? this.targetId.substring(1)
        : this.targetId;

      // Try getElementById first (more robust)
      el = document.getElementById(cleanId);

      // Only if it is not found, we try with querySelector (for compatibility)
      if (!el) {
        try {
          el = document.querySelector(`#${CSS.escape(cleanId)}`);
        } catch (e) {
          console.warn(`[BaseInputWithContextMenu] ⚠️ ID inválido para selector: ${cleanId}`);
        }
      }
      if (!el) {
        return;
      }

      try {
        this.loadMenuItems();
        this.contextMenuInitialized = true;
      } catch (err) {
        console.error('[BaseInputWithContextMenu] ❌ Error inicializando menú:', err);
      }
    });
  }
};
</script>

<style>
.context-menu-disabled {
    opacity: 0.5 !important;
    color: #6c757d !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
    background-color: transparent !important;
}

.context-menu-disabled:hover {
    background-color: transparent !important;
    color: #6c757d !important;
    opacity: 0.5 !important;
}

/* Ensure that styles are applied in all contexts */
.e-contextmenu-container .context-menu-disabled,
.e-menu-popup .context-menu-disabled {
    opacity: 0.5 !important;
    color: #6c757d !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
}
</style>